/**
 * Sysadmin Studio index — redirect to /tools so the parent tab strip
 * lights up correctly when an admin lands at /sysadmin/studio.
 */
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/studio/')({
  component: () => <Navigate to="/sysadmin/studio/tools" replace />,
});
